import App, { AppProps } from 'apps/miru-landing-page'
import { createRoot } from 'react-dom/client'

declare global {
  interface Window {
    MIRU_LANDING_PAGE_REACT_APP_PROPS: AppProps
  }
}

const container = document.getElementById('root')

if (container) {
  try {
    const root = createRoot(container)
    root.render(<App {...window.MIRU_LANDING_PAGE_REACT_APP_PROPS} />)
  } catch (error) {
    console.error('Error rendering React app:', error)
    container.innerHTML = `
      <div style="padding: 20px; text-align: center;">
        <h2>React App Error</h2>
        <p>There was an error rendering the React app.</p>
      </div>
    `
  }
} else {
  console.error('Container element #root not found!')
}
